import { ButtonHTMLAttributes } from 'react';
import Button from 'components/Button/Button';
import Loading from 'components/Loading/Loading';
import COLORS from 'constants/colors';
import { Box } from '@chakra-ui/react';
import { ConnectArrowIcon } from 'components/Icons/ConnectArrowIcon';

interface LoaderButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: string;
  isLoading?: boolean;
  disabled?: boolean;
  text: string;
}

const LoaderButton = ({
  color = COLORS.GRAY.GRAY_900,
  isLoading = false,
  disabled = false,
  onClick,
  text,
  ...props
}: LoaderButtonProps) => (
  <Button
    color={color}
    isLoading={isLoading}
    disabled={disabled || isLoading}
    onClick={onClick}
    {...props}
  >
    {text}
    <Box ml="2" transition="transform 0.2s">
      <ConnectArrowIcon />
    </Box>

    <Loading color={color} isLoading={isLoading} disabled={disabled} />
  </Button>
);

LoaderButton.defaultProps = {
  isLoading: false,
  disabled: false,
};

export default LoaderButton;
